<div class="container-fluid profile-bar">
  <div class="container">
    <!-- Add the PrimeNG input for filtering -->
    <div class="flex flex-column gap-2 mt-4 pt-2">
      <span class="p-input-icon-right w-100">
        <i class="pi pi-search"></i>
        <input pInputText [(ngModel)]="filterText" (input)="applyFilter()" placeholder="{{ 'Search...' | translator }}"
          class="full-width-input p-inputtext-lg" />
      </span>
    </div>
  </div>
</div>

<div class="container">
  <div class="row">

    <div *ngFor="let item of filterItems" class="col-12 col-sm-6 col-md-4 my-2 py-2"
      [hidden]="!checkDataCountValues(item)">
      <div class="card itemview eService-mini-card p-5">
        <div class="card-body">
          <div class="d-flex">
            <img *ngIf="checkisImg(object.image); else parentelseBlock" src="{{ siteUrl }}{{ object.image }}"
              class="img-fluid p-1" style="max-height: 30px; max-width: 30px" />
            <ng-template #parentelseBlock>
              <i class="{{ object.image }} p-2" style="font-size: 1rem"></i>
            </ng-template>
            <b class="text-wrap" [innerHTML]="object.name | highlight : filterText"></b>

            <p class="ms-3" [innerHTML]="item.id"></p>
          </div>

          <div class="d-flex flex-row flex-nowrap align-items-center">
            <div *ngIf="gotoLink != 'data'" class="d-flex">
              <img *ngIf="checkisImg(item.image); else parentelseBlock" src="{{ siteUrl }}{{ item.image }}"
                class="p-1 Eservice-img" />
              <ng-template #parentelseBlock>
                <i class="{{ item.image }} p-2" style="font-size: 2rem"></i>
              </ng-template>
            </div>

            <h4 class="all-items-title" [innerHTML]="item.name | highlight : filterText"></h4>
          </div>

          <ng-container *ngIf="isLoggedIn;else defaultTemplate">
            <div *ngIf="
              item?.data_counter && isObject(item.data_counter);
              else counterelseBlock
            ">
              <p-tag *ngFor="
                let counter of item.data_counter | keyvalue;
                let i = index
              " [rounded]="false" icon="{{ dataTypes[converttostring(counter.key)] }} pi-fw"
                styleClass="bg-color-{{ i }} me-2" [pTooltip]="converttostring(counter.key)">
                {{ counter?.value }}
              </p-tag>
            </div>

            <ng-template #counterelseBlock>
              <p-tag *ngFor="
                let counter of dataSorter(item.data_counter);
                let i = index
              " [rounded]="false" icon="{{ counter.icon }} pi-fw" styleClass="bg-color-{{ i }} me-2"
                [pTooltip]="counter._id">
                {{ counter?.count }}
              </p-tag>
            </ng-template>
          </ng-container>


          <ng-template #defaultTemplate>
            <ng-container *ngIf="checkOuIdExists(item._id);else unsignedTemplate">
              <div *ngIf="!!item?.data_counter_signed && isObject(item.data_counter_signed)">
                <p-tag *ngFor="
                  let counter of item.data_counter_signed | keyvalue;
                  let i = index" [rounded]="false" icon="{{ dataTypes[converttostring(counter.key)] }} pi-fw"
                  styleClass="bg-color-{{ i }} me-2" [pTooltip]="converttostring(counter.key)">
                  {{ counter?.value }}
                </p-tag>
              </div>
            </ng-container>
            <ng-template #unsignedTemplate>
              <div *ngIf="!!item?.data_counter && isObject(item.data_counter);else counterelseBlockunsigned">
                <p-tag *ngFor="
                  let counter of item.data_counter | keyvalue;
                  let i = index" [rounded]="false" icon="{{ dataTypes[converttostring(counter.key)] }} pi-fw"
                  styleClass="bg-color-{{ i }} me-2" [pTooltip]="converttostring(counter.key)">
                  {{ counter?.value }}
                </p-tag>
              </div>
              <ng-template #counterelseBlockunsigned>
                <p-tag *ngFor="
                    let counter of dataSorter(item.data_counter);
                    let i = index
                  " [rounded]="false" icon="{{ counter.icon }} pi-fw" styleClass="bg-color-{{ i }} me-2"
                  [pTooltip]="counter._id">
                  {{ counter?.count }}
                </p-tag>
              </ng-template>
            </ng-template>
          </ng-template>



          <div *ngIf="item?.type && gotoLink == 'data'">
            <p-tag [rounded]="false" icon="{{ item.type.icon }} pi-fw" styleClass="bg-color-{{ 1 }} me-2">
              {{ item.type.arabic }}
            </p-tag>
          </div>

          <div class="d-flex pt-2">
            <button class="v4-btn-every" *ngIf="gotoLink != 'data'" [routerLink]="gotoLink"
              [queryParams]="{ id: item.id, type: datatype }">
              <i class="pi pi-search m-l-1"></i>{{ "the details" | translator }}
            </button>
            <button class="v4-btn-every" *ngIf="gotoLink == 'data'" [routerLink]="'/data/' + item.id">
              <i class="pi pi-search m-l-1"></i>{{ "the details" | translator }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="filterItems && filterItems.length < 1">
      <div class="container-fluid" style="min-height: 400px">
        <div class="container d-flex justify-content-center">
          <h5 class="la-tujad mt-5 pt-5">
            {{ "There is no data" | translator
            }}<i class="pi pi-fw pi-exclamation-triangle font-2rem mx-2"></i>
          </h5>
        </div>
      </div>
    </div>
  </div>
</div>